<template>
 <div 
    ref="searchBar"
    class="search-bar position-relative d-flex align-items-center w-100 px-4">
        <label 
            v-if="searchText === ''" 
            class="position-absolute p5n" 
            for="search">
                <span class="c3">Search</span>
                <span class="c10 "> by Campaign and Category</span>
        </label>
        <input 
            @keyup.enter="toAdvancedSearch"
            v-model="searchText"
            class="w-100 p3n border-0" 
            type="text" 
            name="search"
            ref="search"
            id="search">
        <button 
            @click="hide"
            id="search-close"
            style="z-index: 10"
            class="position-absolute">
                <CloseCross/>
        </button>
        <div :class="{'d-none': !searchText.length}">
            <div class="quick-search w-100 position-absolute d-flex flex-column">
                <div class="search-body mx-4 py-3">
                    <div id="search-name">
                        <p class="lab c7 mb-1">By Name</p>
                        <div 
                            v-for="({name, id}, index) in names.slice(0, 2)" 
                            :key="`${name}-${index}`"
                            @click="hide">
                                <router-link 
                                    @click.native = "fireSearchEvent('Name')"
                                    :to="{path: `/campaigns/${id}`}">
                                    <p class="p5n c6">{{name}}</p>
                                </router-link>
                        </div>
                    </div>
                    <div id="search-category">
                        <p class="lab c7 mb-1">By Category</p>
                        <div v-for="({name, id}, index) in categories.slice(0, 2)" :key="`${name}-${id}-${index}`">
                            <router-link 
                                @click.native = "fireSearchEvent('Category')"
                                :to="{path: `/campaigns/${id}`}">
                                <p class="p5n c6">{{name}}</p>
                            </router-link>
                        </div>
                    </div>
                </div>
                <div v-if="!isEcommercePlatform" class="search-footer mx-4 my-auto">
                    <span 
                        style="cursor: pointer;"
                        class="p2n c6" 
                        @click="toAdvancedSearch">
                        Advanced Search
                    </span>
                </div>
            </div>
        </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import { ELASTIC_SEARCH_CAMPAIGNS_INDEX } from '../firebase'
import { CloseCross } from './Icons'

export default {
    name: 'SearchBar',
    components: {
        CloseCross,
    },
    data: function() {
        return {
            searchText: '',
            names: [],
            categories: [],
            throttling: null,
        }
    },
    watch: {
        'searchText': 'do_search'
    },
    computed: {
        ...mapGetters(['isEcommercePlatform'])
    },
    mounted: function () {
        this.$refs.search.focus()
        setTimeout(() => {
            document.querySelector('body').addEventListener('click', this.onOutsideClick)
        }, 0)
    },
    destroyed: function () {
        document.querySelector('body').removeEventListener('click', this.onOutsideClick)
    },
    methods: {
        onOutsideClick: function (e) {
            if (this.$refs.searchBar.contains(e.target)) {
                return
            }

            this.hide()
        },
        hide: function () {
            this.$emit('hide')
        },
        toAdvancedSearch: function() {
            if(this.isEcommercePlatform ) {
                return
            }
            this.$router.replace({
                path: '/advanced-search',
                query: {
                    searchText: this.searchText
                }
            })
            .catch(() => {})
            this.hide()
        },
        search_by_name() {
            axios.post(`https://search.crossprom.com/${ELASTIC_SEARCH_CAMPAIGNS_INDEX}/_search`, {
                query: {
                    bool: {
                        must: {
                            query_string: {
                                fields: ['title'],
                                // remove all special characters for preventing an Elastic error response
                                query: `*${this.searchText.replace(/[^a-zA-Z ]/g, "")}*`,
                            }
                        },
                        must_not: {
                            exists: {
                                field: 'hidden'
                            }
                        }
                    }
                }
            })
            .then(
                (response) => {
                    this.names = response.data.hits.hits.map(
                        hit => ({
                            name: hit._source.title, 
                            id: hit._source.id
                        })
                    )

                    
                }
            )
        },
        search_by_category() {
            axios.post(`https://search.crossprom.com/${ELASTIC_SEARCH_CAMPAIGNS_INDEX}/_search`, {
                query: {
                    match: {
                        category: {
                            query: this.searchText,
                            operator: 'and',
                        }
                    }
                }
            })
            .then(
                (response) => {
                    this.categories = response.data.hits.hits.map(
                        hit => ({
                            name: hit._source.title,
                            id: hit._id,
                        })
                    )
                    
                }
            )
        },
        do_search(val) {
            if(!val) return;
            if (this.throttling) {
                clearTimeout(this.throttling)
                this.throttling = null
            }

            this.throttling = setTimeout(() => {
                this.search_by_name()
                this.search_by_category()
            }, 700)
        },
        fireSearchEvent(searchedBy){
            const resultsCount = searchedBy === 'Category' ? this.categories.length : this.names.length
            this.$ga.event('Search', 'Navbar Search', `
                Keyword: ${this.searchText},
                ResultsCount: ${resultsCount},
                SearchedBy: ${searchedBy}
            `)

            this.$sendMixpanelEvent('Search', {
                'Search Location': 'Navbar Search',
                'Keyword': this.searchText,
                'Results Count': resultsCount,
                'Searched By': searchedBy
            });
        }
    }
}
</script>

<style lang="scss" scoped>
    div.search-bar {
        label {
            left: 25px;
            cursor: inherit
        }
        button {
            right: 25px;
        }
    }
    div.quick-search {
        height: 305px;
        background: #ffffff;
        box-shadow: 0 18px 23px rgba(0, 0, 0, 0.05);
        left: 0;
        top: 100%;
        z-index: 9999;

        transform: translateY(6%);

        div.search-body {
            height: 243px;
            overflow-y: auto;
            border-top: 1px solid #0000000d;
            border-bottom: 1px solid #0000000d;
        }
    }
</style>